import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Collection } from '../classes/collection';
import { JsonLdService } from '../service/jsonld.service';
import { MercuryService } from '../service/mercury.service';
import { ThemeService } from '../service/theme.service';
import { ResolverErrorService } from './resolver-error.service';

@Injectable({ providedIn: 'root' })
export class CollectionResolver implements Resolve<any> {
  _url: string = '';
  constructor(
    private mercuryService: MercuryService,
    private themeService: ThemeService,
    private jsonLdService: JsonLdService,
    private resolverError: ResolverErrorService
  ) {}

  async resolve(route: ActivatedRouteSnapshot): Promise<any> {
    const handle = route.paramMap.get('handle') as string;

    const queryParams = route.queryParams;
    return await this.mercuryService
      .getFilteredCollection(
        handle,
        this.mercuryService.calculateFilters(queryParams),
        queryParams?.sort || '',
        20,
        queryParams?.page ? (queryParams?.page - 1) * 20 : 0
      )
      .toPromise()
      .then((result: Collection | any) => {
        if (!result) {
          return this.resolverError.showNotFound();
        }
        this._url = handle;
        this.themeService.viewCollection(result);
        this.jsonLdService.generateCollectionJsonLd(result);
        return {
          ...result,
          seo: {
            title: result?.metafields?.global?.title_tag || result?.title,
            description:
              result?.metafields?.global?.description_tag ||
              result?.body_html,
          },
        };
      })
      .catch((err) => this.resolverError.handle(err));
  }
}
